// The site is delivered as a single autonomous HTML file in public/index.html.
// React mounts to an empty #root and renders nothing so the static markup shows.
function App() {
  return null;
}

export default App;
